import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {useBreakpointUp} from '@travel-frontend/core';
import {SPACING_SMALL, Stack} from '@travel-frontend/ui-components';

type Props = React.PropsWithChildren<{className?: string}>;

export const TextWrapper = styled(({className, children}: Props) => {
  const mdUp = useBreakpointUp('md');
  const alignItems = mdUp ? 'center' : 'flex-start';

  return (
    <Stack
      spacing={SPACING_SMALL}
      alignItems={alignItems}
      className={className}
    >
      {children}
    </Stack>
  );
})(
  ({theme}) => css`
    position: relative;

    ${theme.respondTo(
      'md',
      css`
        text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.25);
        text-align: center;
      `
    )}
  `
);
